import { Component, OnDestroy, forwardRef, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';


import { NCT } from '@atmi/core/models';
import { BaseCtrlValueAccessorFormComponent } from '@sim/form/components/base-ctrl-value-accessor-form.component';

@Component({
  selector: 'app-nct-form',
  templateUrl: './nct-form.component.html',
  styleUrls: ['./nct-form.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NctFormComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => NctFormComponent),
      multi: true,
    }
  ]
})
export class NctFormComponent extends BaseCtrlValueAccessorFormComponent<NCT> implements OnDestroy, OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

}
